import { useEffect, useState, useRef } from "react";
import { api, resolveImg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Upload, Check } from "lucide-react";
import { toast } from "sonner";

export function MediaPickerDialog({ open, onOpenChange, onSelect }) {
  const [items, setItems] = useState([]);
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);

  const load = () => api.get("/admin/media", { params: { limit: 60 } }).then((r) => setItems(r.data.items));

  useEffect(() => { if (open) load(); }, [open]);

  const onFiles = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    const fd = new FormData();
    files.forEach((f) => fd.append("files", f));
    setUploading(true);
    try {
      await api.post("/admin/media/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Bild(er) hochgeladen.");
      load();
    } catch { toast.error("Upload fehlgeschlagen."); }
    finally { setUploading(false); if (fileRef.current) fileRef.current.value = ""; }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-offwhite border-edborder max-w-3xl">
        <DialogHeader>
          <DialogTitle className="font-headline text-2xl text-prussian">Mediathek</DialogTitle>
        </DialogHeader>
        <div className="flex items-center justify-between">
          <p className="text-sm text-muted-foreground font-body">Bild auswählen oder neue hochladen.</p>
          <button data-testid="media-picker-upload-btn" onClick={() => fileRef.current?.click()} disabled={uploading}
            className="inline-flex items-center gap-2 bg-prussian text-white text-sm font-body px-4 py-2 hover:bg-prussian-dark disabled:opacity-50">
            <Upload size={15} /> {uploading ? "Lädt…" : "Hochladen"}
          </button>
          <input ref={fileRef} type="file" accept="image/*" multiple hidden onChange={onFiles} />
        </div>
        <div className="grid grid-cols-3 sm:grid-cols-4 gap-3 max-h-[420px] overflow-y-auto mt-2">
          {items.map((m) => (
            <button key={m.id} type="button" data-testid={`media-pick-${m.id}`}
              onClick={() => { onSelect(m.url); onOpenChange(false); }}
              className="group relative aspect-square bg-white border border-edborder overflow-hidden hover:border-prussian">
              <img src={resolveImg(m.url)} alt={m.alt || m.original_filename} className="w-full h-full object-cover" />
              <span className="absolute inset-0 bg-prussian/0 group-hover:bg-prussian/30 flex items-center justify-center transition-colors">
                <Check className="text-white opacity-0 group-hover:opacity-100" size={22} />
              </span>
            </button>
          ))}
          {items.length === 0 && <p className="col-span-full text-center text-muted-foreground py-10 font-body text-sm">Noch keine Bilder. Laden Sie welche hoch.</p>}
        </div>
      </DialogContent>
    </Dialog>
  );
}
